module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASVJREFUeNrs12ENwyAQBeBKQMIkVEolTAIS5mASkICESZgEJEwCK9ktuRBaSpsAj9xLmibtn/sCvaPTJJFIqsV7r9ZrGQHx9r/cR0B4SEyECHcNh0kgFD2/w2C2EOw9BiYHQcR84DFrYSbqVHgYhgjF3yC2GW0hvYFQEN9MVKBJIQobAJ8zSwtE9lvIYY5Aa09sXdqamyCoGHtlYlMD4CtYH0GFhLgzE/vMlqwOyWESCMtWRLVouaa0lUYIy6a+bYI4idEM4ej9zDCmpwmew/i4cGSM5QMUEcPnzAMSc2AA9o8pOJJ0jXF07W05GEzIa29OdI+58jsgGMEI5hDGjYKZuz6bCWZwzD9PWAw7PYRn84SUCIOJSGBwEREGGyGRSCTj5yvAAEIDAVlq7oUBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Iconos/4.png
// module id = +HnG
// module chunks = 0